<template>
  <transition name="fade" enter-active-class="afdc-animated afdc-animated-fast afdc-slideInLeft" leave-active-class="afdc-animated afdc-animated-fast afdc-slideOutLeft" v-on:after-enter="afterEnter">
    <div v-if="displayDirections" id="afdc-corridor-direction-container" tabindex="0" v-on-clickaway="closePopup">
      <button id="afdc-close-directions" class="afdc-float-right" v-on:click="closePopup">
        <span class="afdc-sr-only">{{ $t('Close') }}</span>
        <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
      </button>
      <h3>Route Directions</h3>
      <div v-for="direction in routeDirections" :key="direction.key">
        <div class="afdc-row afdc-no-gutters afdc-direction-row">
          <div class="afdc-col-md-1">
            <font-awesome-icon class = "afdc-direction-icon" :class="directionIconColor(direction.icon)" :icon="direction.icon" />
          </div>
          <div class="afdc-col-md-8">
            <span v-html ="direction.narrative"></span>
          </div>
          <div class="afdc-col-md-3 afdc-d-flex afdc-justify-content-end">
            {{direction.distance}}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'DirectionsPopup',

  mixins: [
    clickaway,
  ],

  data() {
    return {
      displayDirections: false,
      directionMode: '',
    };
  },

  computed: {
    routeDirections() {
      const directionArray = this.getDirections();
      const maneuvers = [];
      if (directionArray.length) {
        directionArray.forEach((direction, index) => {
          maneuvers.push(
            {
              distance: this.formatDistance(direction.distance),
              narrative: direction.narrative,
              icon: 'car',
              key: `direction-${index}`,
            },
          );
        });
        // changes the first and last icons to start and stop icons
        maneuvers[0].icon = 'play-circle';
        maneuvers[maneuvers.length - 1].icon = 'stop-circle';
      }
      return maneuvers;
    },
  },

  watch: {
    '$store.getters.getDirectionPopup': {
      immediate: true,
      handler: 'setDirectionsDisplay',
    },
    '$store.getters.getNavActiveTab': {
      immediate: true,
      handler: 'checkClose',
    },
  },
  created() {
    this.directionMode = this.$store.getters.getNavActiveTab;
  },
  methods: {
    checkClose() {
      const newTab = this.$store.getters.getNavActiveTab;
      if (newTab !== this.directionMode) {
        this.closePopup();
      }
    },
    getDirections() {
      if (this.$store.getters.isNavActiveTabCorridors
          && this.$store.getters.isNavActiveTabCorridorsSearchPresent) {
        return this.$store.getters.getCorridorDirections;
      } if (this.$store.getters.isNavActiveFindModeRoute
          && this.$store.getters.isNavActiveFindModeRouteSearchPresent) {
        return this.$store.getters.getRouteDirections;
      }
      return [];
    },

    setDirectionsDisplay() {
      this.displayDirections = this.$store.getters.getDirectionPopup;
    },

    afterEnter() {
      this.focusOnLoad();
    },

    focusOnLoad() {
      if (this.$el) {
        this.$el.focus();
      }
    },

    closePopup() {
      this.$store.commit('setDirectionPopup', false);
    },

    directionIconColor(icon) {
      if (icon === 'play-circle') {
        return 'afdc-start-direction-color';
      }
      if (icon === 'stop-circle') {
        return 'afdc-stop-direction-color';
      }
      return '';
    },

    formatDistance(number) {
      const distanceFormat = { minimumFractionDigits: 1, maximumFractionDigits: 1 };
      const distance = this.$formatNumber(number, distanceFormat);
      return this.$sprintf(this.$t('%s miles'), distance);
    },
  },
};
</script>

<style lang="scss">
  #corridor-direction-container {
    position: absolute;
    background: white;
    z-index: 15;
    width: 90%;
    max-width: 1000px;
    height: 100%;
    overflow: auto;
    padding: 20px 40px;
    border: 1px solid #ccc;
    box-shadow: 5px 0px 10px 0px #a3a3a3;

    #close-directions {
      font-size: 32px;
      margin: -15px -5px -5px 0;
    }

    .fa-icon {
      color: #999;
      &:hover {
        color: #666;
        cursor: pointer;
      }
    }

    .direction-icon {
      font-size: 25px;
      color: #666;
    }

    .start-direction-color {
      color: #438f37;
    }

    .stop-direction-color {
      color: #dd4733;
    }

    .direction-row {
      padding-top: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #999;
      border-width: 90%;
    }
  }

</style>
